import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { ProjectAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/project/project-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const ProjectAccessRulesConst: Record<ProjectAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль PROJECT (Задачи) ---
  // --- Раздел PROJECT.SECTIONS.PROJECT (Задачи) ---

  // Вкладка "Задачи"
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TASK_READ]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.PROJECT.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TASK_WRITE]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.PROJECT.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Вкладка "Календарь событий"
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_EVENT_CALENDAR_READ]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.EVENT_CALENDAR.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_EVENT_CALENDAR_WRITE]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.EVENT_CALENDAR.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Вкладка "Трудозатраты"
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TIME_REPORT_READ]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.TIME_REPORT.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  // Вкладка "Шаблоны"
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TEMPLATE_READ]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_TEMPLATE_WRITE]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.tabs.TEMPLATE.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_CAN_READ_ALL_PROJECTS]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.permissions.CAN_READ_ALL_PROJECTS.isAllowed': true
  },
  [ProjectAccessRulesKeyEnum.PROJECT_PROJECT_DELETE_OTHER_USER_COMMENTS]: {
    'PROJECT.enabled': true,
    'PROJECT.sections.PROJECT.permissions.DELETE_OTHER_USER_COMMENTS.isAllowed': true
  }
};
